import RouteBase from '@/router/routes/RouteBase.js';

class RoutesTtec {
  subFolderPath = '/businessPartners/ttec';
  isPublic = false;

  Home = new RouteBase({
    name: 'ttec-home',
    path: '',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'Home',
    isPublic: this.isPublic,
    meta: {
      appbarConfig: {
        isCollapsable: false,
        icon: 'wave',
        title: 'Ttec',
        hasBackButton: true,
      },
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Ttec',
        },
      ],
    },
  });

  Brand = new RouteBase({
    name: 'brand',
    path: ':brand/:id',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'Brand',
    isPublic: this.isPublic,
    meta: {
      appbarConfig: {
        isCollapsable: false,
        hasBackButton: true,
      },
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Ttec',
          link: '/secure/business-partners/ttec',
        },
        {
          name: 'Kategori',
        },
      ],
    },
  });

  List = new RouteBase({
    name: 'list',
    path: 'price-list',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'List',
    isPublic: this.isPublic,
    meta: {
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'Ttec',
          link: '/secure/business-partners/ttec',
        },
        {
          name: 'Güncel Fiyat Listesi',
        },
      ],
    },
  });
}

export default new RoutesTtec();
